$(document).ready(function () {
  var debugReturn = $("#enjp-return-app").data("debug-return") === true || $("#enjp-return-app").attr("data-debug-return") === "true";
  if (debugReturn) {
    console.log("[enjp-return] Debug mode: API responses will be faked as success.");
  }

  if ($("#readytosendthereturn").length > 0) {
    $(".returnstatus").each(function () {
      var $t = $(this);
      if (debugReturn) {
        return;
      }
      console.log(
        "chiamata " +
          "https://www.enterprise-japan.com/apps/myreturns/?sku=" +
          $(this).attr("data-sku") +
          "&action=verifystatusreturn"
      );
      $.ajax({
        method: "POST",
        url:
          "https://www.enterprise-japan.com/apps/myreturns/?sku=" +
          $(this).attr("data-sku") +
          "&action=verifystatusreturn"
      }).done(function (msg) {
        if (msg != "ok") {
          $t.html(msg);
          $t.parent().parent().find(".blockcheckchoicereturnedqty").css("display", "none");
          $t.parent().parent().find(".choicereturnedqty").css("display", "none");
          $t.parent().parent().find(".blockcheckchoicereturnedqty").addClass("deactivated");
          $t.parent().parent().find(".choicereturnedqty").addClass("deactivated");
          $t.parent().parent().find(".blockchoicereturneditemreason").css("display", "none");
          $("#readytosendthereturn").css("display", "none");
          $(".handlemyreturnpreview").html(
            "Esiste un reso per questo ordine, non è possibile rendere altri articoli"
          );
          $(".blockchoicereturnedqty").css("display", "none");
          $(".order-table tr th:nth-child(1)").css("display", "none");
        }
      });
    });

    var noreturnskus = 0;
    $(".blockcheckchoicereturnedqty").each(function () {
      if ($(this).hasClass("deactivated")) {
        noreturnskus = 1;
      } else {
        noreturnskus = 0;
      }
    });

    if (noreturnskus == 1) {
      $(".handlemyreturnpreview").attr("id", "return-preview-msg").html("*nessun articolo rendibile presente");
      $("#readytosendthereturn").css("display", "none");
    }

    $(".choicereturnedqty").blur(function () {
      let qtychoice = 0;
      let qtymax = 0;
      let isreadytosend = 0;
      let productstobereturned = "";
      $(".blockcheckchoicereturnedqty").each(function () {
        if ($(this).prop("checked")) {
          isreadytosend = 1;
          qtychoice = parseInt($(this).parent().next().find(".choicereturnedqty").val());
          if (isNaN(qtychoice) || qtychoice < 1) {
            isreadytosend = 0;
          } else {
            qtymax = parseInt($(this).parent().next().find(".choicereturnedqty").attr("data-max"));
            if (qtychoice > qtymax) {
              $(this).parent().next().find(".choicereturnedqty").val(qtymax);
              qtychoice = qtymax;
            }
            if (productstobereturned != "") {
              productstobereturned = productstobereturned + "#";
            }
            productstobereturned =
              productstobereturned + $(".blockcheckchoicereturnedqty").val() + "|" + qtychoice;
          }
        }
      });
    });

    $(".reasonwithdraw").change(function () {
      if ($(this).val() == "05") {
        $(this).parent().find(".boxchoicewithdrw").css("display", "block");
      } else {
        $(this).parent().find(".boxchoicewithdrw").css("display", "none");
      }
    });

    $("#readytosendthereturn").click(function (e) {
      let qtychoice = 0;
      let qtymax = 0;
      let isreadytosend = 0;
      var productstobereturned = "";
      let reason = "";
      let selected = 0;
      let replacedsize = "";
      $(".blockcheckchoicereturnedqty").each(function () {
        if ($(this).prop("checked")) {
          selected++;
          isreadytosend = 1;
          qtychoice = parseInt($(this).parent().next().find(".choicereturnedqty").val());
          reason = $(this)
            .parent()
            .parent()
            .parent()
            .find(".order-table__product .blockchoicereturneditemreason select")
            .val();
          replacedsize = $(this)
            .parent()
            .parent()
            .parent()
            .find(".order-table__product .sizeavaiabletoreplace")
            .val();
          console.log("reason " + reason);
          console.log(replacedsize);

          if (isNaN(qtychoice) || qtychoice < 1) {
            console.log("Check qty empty or less than 1");
            qtymax = parseInt($(this).parent().next().find(".choicereturnedqty").attr("data-max"));
            $(this).parent().next().find(".choicereturnedqty").val(qtymax);
            qtychoice = qtymax;
            isreadytosend = 0;
            $(this).parent().next().find(".choicereturnedqty").css("border", "1px solid #f00");
            if (reason.trim() == "") {
              console.log("set error");
              isreadytosend = 0;
              $(this)
                .parent()
                .parent()
                .parent()
                .find(".order-table__product .blockchoicereturneditemreason select")
                .css("color", "#f00");
            }
          } else {
            console.log("adding product to be returner into json");
            qtymax = parseInt($(this).parent().next().find(".choicereturnedqty").attr("data-max"));
            if (qtychoice > qtymax) {
              $(this).parent().next().find(".choicereturnedqty").val(qtymax);
              qtychoice = qtymax;
            }
            if (productstobereturned != "") {
              productstobereturned = productstobereturned + "#";
            }
            console.log("product to be returned " + $(this).val());
            productstobereturned =
              productstobereturned + $(this).val() + "|" + qtychoice + "|" + reason + "|" + replacedsize;
          }
          $(this).parent().parent().find(".handlemyreturnpreview").css("color", "#f00");
          $(this).parent().parent().find(".blockchoicereturnedqty.w50l").css("border-bottom", "3px solid #f00");
          $(this).parent().parent().find(".blockchoicereturnedqty.w50l").css("width", "15px");
          console.log(
            "Ragione reso: " +
              $(this)
                .parent()
                .parent()
                .parent()
                .find(".order-table__product .blockchoicereturneditemreason   .reasonwithdraw")
                .val()
          );
          if (
            $(this)
              .parent()
              .parent()
              .parent()
              .find(".order-table__product .blockchoicereturneditemreason   .reasonwithdraw")
              .val() == "05"
          ) {
            console.log(
              "taglia scelta " +
                $(this)
                  .parent()
                  .parent()
                  .parent()
                  .find(".order-table__product .blockchoicereturneditemreason   .sizeavaiabletoreplace")
                  .val()
            );
            if (
              $(this)
                .parent()
                .parent()
                .parent()
                .find(".order-table__product .blockchoicereturneditemreason   .sizeavaiabletoreplace")
                .val() == ""
            ) {
              isreadytosend = 0;
              console.log("advice");
              $(this)
                .parent()
                .parent()
                .parent()
                .find(".order-table__product .blockchoicereturneditemreason .sizeavaiabletoreplaceadvice")
                .css("display", "block");
            }
          }
        }
      });

      function onSendReturnSuccess(msg) {
        if (msg == "ok") {
          $("#step1").css("display", "none").attr("aria-hidden", "true");
          $("#step2").css("display", "block").attr("aria-hidden", "false");
          var step2Heading = document.getElementById("return-step2-heading");
          if (step2Heading) {
            step2Heading.setAttribute("tabindex", "-1");
            step2Heading.focus();
          }
        }
        if (msg == "notavaiable") {
          $("#readytosendthereturn").css("display", "none");
          $(".handlemyreturnpreview").html(
            "Esiste un reso per questo ordine, non è possibile rendere altri articoli"
          );
        }
      }

      if (debugReturn) {
        $(".handlemyreturnpreview").css("color", "#000");
        onSendReturnSuccess("ok");
      } else if (isreadytosend == 1) {
        $(".handlemyreturnpreview").css("color", "#000");
        $(".blockchoicereturnedqty.w50l").css("border-bottom", "0px solid #f00");
        $(".blockchoicereturnedqty.w50l").css("width", "15px");
        $.ajax({
            method: "POST",
            url:
              "https://www.enterprise-japan.com/apps/myreturns/?orderid=" +
              $("#currentorder").val() +
              "&currentcustomer=" +
              $("#currentcustomer").val() +
              "&ordername=" +
              $("#currentordername").val().replace("#", "") +
              "&action=sendreturn",
            data: {
              products: productstobereturned
            }
          }).done(onSendReturnSuccess);
      } else {
        if (selected == 0) {
          $(".handlemyreturnpreview").css("color", "#f00");
        }
      }
    });

    $("#readytosavethereturn").click(function (e) {
      console.log("#1");
      let validate = 0;
      var withdrawaladdress = {};
      $("#shippingcustomer input").each(function () {
        if ($(this).val().trim() == "") {
          $(this).css("border", "1px solid #f00");
          validate = 1;
          console.log("elemento vuoto " + $(this).attr("id"));
        } else {
          $(this).css("border", "1px solid #000");
        }
        withdrawaladdress[$(this).attr("name")] = $(this).val();
      });
      withdrawaladdress["message"] = $("#message").val();
      console.log(withdrawaladdress);

      if (validate == 0 || debugReturn) {
        $("#readytosavethereturn").css("pointer-events", "none");

        function onCloseReturnSuccess(msg) {
          $("#readytosavethereturn").css("pointer-events", "all");
          if (msg == "ok") {
            $("#enjp-return-app").css("display", "none");
            $(".returnsent").css("display", "flex");
          }
        }

        if (debugReturn) {
          onCloseReturnSuccess("ok");
        } else {
          $.ajax({
            method: "POST",
            url:
              "https://www.enterprise-japan.com/apps/myreturns/?orderid=" +
              $("#currentorder").val() +
              "&action=closereturn",
            data: {
              address: withdrawaladdress
            }
          }).done(onCloseReturnSuccess);
        }
      }
    });
  }
});
